export enum SubscriberParameterEnum {
  BASE_AMMENITY_TYPE = "BASE_AMMENITY_TYPE",
  SEND_NOTIFICATIONS = "SEND_NOTIFICATIONS",
  FRO_DATE_FROM_WEB = "FRO_DATE_FROM_WEB",
  IGNORE_MULTI_HOTEL ="IGNORE_MULTI_HOTEL",
  L_PARENT_EMPLOYEES = "L_PARENT_EMPLOYEES",
  SHOW_PERFORMANCE  = "SHOW_PERFORMANCE",
  EXTRA_RIGHTS = "EXTRA_RIGHTS",
  CLEANING_WAGE_COST ="CLEANING_WAGE_COST",
  MATERIAL_CONSUMPTION = "MATERIAL_CONSUMPTION"
}
